<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="specimenSource">
      <specimen-source-form
        :isLoading="isLoading"
        :specimenSource="specimenSource"
        :onSubmit="onSubmit">
      </specimen-source-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenSourceForm from './SpecimenSourceForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { medicalRegistry } = services;
const { specimenSourceService } = medicalRegistry;

export default {
  name: 'SpecimenSourceUpdate',
  components: {
    SpecimenSourceForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Specimen Source',
      enableBackButton: true,
    },
    specimenSource: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const specimenSource = await specimenSourceService.getOne({ id });
    this.specimenSource = specimenSource;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.specimenSource || {}, dataChange);

      this.isLoading = true;
      try {
        await specimenSourceService.update({ specimenSource: data });

        this.$snackbar.showOk({ text: 'Successfully updated specimen source!' });

        this.$router.push({ name: 'specimen-source.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
